module.exports = __webpack_public_path__ + "static/media/car-pickup.e8f4d055.png";